import React from "react";
import { API_BASE_URL,ACCESS_TOKEN } from '../settings/shared/constants';

class AuthService extends React.Component {
  
  checkFunction() {
    // console.log('Click happened');
  }
}


const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    })
    
    if(localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
    }

    const defaults = {headers: headers};
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
    .then(response => 
        response.json().then(json => {
            if(!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
    );
};

export function getCurrentUser() {
    if(!localStorage.getItem(ACCESS_TOKEN)) {
        return Promise.reject("No access token set.");
    }
    
    return request({
        url: API_BASE_URL + "/api/v1.0/user/me",
        method: 'GET'
    });
}


export default AuthService;
